module.exports = __webpack_public_path__ + "img/proList2_27_06.b8c81573.jpg";